let features = null;
export function haveFeaturesBeenInitialized() {
  return features !== null;
}
export function init(evaluatedFeatures) {
  if (!evaluatedFeatures) {
    features = new Map();
    return;
  }
  features = new Map(Object.keys(evaluatedFeatures).map(key => [key, evaluatedFeatures[key]]));
}
export function isActive(feature) {
  if (features != null) {
    return features.get(feature) || false;
  } else {
    throw Error('Features are not initialized yet');
  }
}